import React, { Ref } from 'react'

import Select, { SelectProps } from 'components/ui/Select/Select'

const PartnerInvitationUnlinkedSelect = React.forwardRef(
  (props: SelectProps, ref: Ref<HTMLInputElement>): JSX.Element => {
    const options = [
      { value: 'true', text: 'Unlinked Only' }
    ]

    return (
      <div className="relative rounded-md shadow-sm w-full">
        <Select options={options} {...props} ref={ref} />
      </div>
    )
  }
)

export default PartnerInvitationUnlinkedSelect
